import React from 'react';
import { Container, StyledButton } from './styles';
import { Typography } from '@mui/material';
import { RefreshOutlined } from '@mui/icons-material';
import WarningIcon from '../../../../assets/images/warning-secondary-icon.png';
import ErrorIcon from '../../../../assets/images/not-found-icon.png';

export const ListFeedback = ({ isError }) => {
  return isError ? (
    <Container>
      <img src={ErrorIcon} alt="Error" width={88} height={88} />
      <Typography>
        Ops! Parece que tivemos um erro interno. Tente novamente mais tarde.
      </Typography>
      <StyledButton onClick={() => history.go(0)}>
        <RefreshOutlined /> Recarregar
      </StyledButton>
    </Container>
  ) : (
    <Container>
      <img src={WarningIcon} alt="Warning" width={88} height={88} />
      <Typography>Ops! Parece que não encontramos nenhum resultado.</Typography>
      <StyledButton onClick={() => history.go(0)}>Limpar filtros</StyledButton>
    </Container>
  );
};
